const genres: any = [
    "Action",
    "Adventure",
    "Animation",
    "Biography",
    "Comedy",
    "Crime",
    "Documentary",
    "Drama",
    "Family",
    "Fantasy",
    "Film-Noir ",
    "History",
    "Horror",
    "Music",
    "Musical",
    "Mystery",
    "Romance",
    "Sci-Fi ",
    "Sport",
    "Thriller",
    "War",
    "Western",
    "Short ",
    "News ",
    "Other"
];

class GenreService {

    getAllGenres() {
        return genres;
    }

};

export const genreService = new GenreService();